module.exports = __webpack_public_path__ + "img/upzfb.b214fc8c.png";